(() => {
  const root = document.querySelector('.lp-quote-carousel');
  if (!root) return;
  const slides = [...root.querySelectorAll('[data-student-quote]')];
  const controls = root.querySelector('.lp-quote-controls');
  const toggle = root.querySelector('[data-quote-toggle]');
  let index = 0;
  let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer;
  const show = next => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
    root.querySelector('[data-quote-count]').textContent = `${index + 1} / ${slides.length}`;
  };
  const schedule = () => {
    clearInterval(timer);
    toggle.textContent = paused ? 'Play quotes' : 'Pause quotes';
    if (!paused && !document.hidden) timer = setInterval(() => show(index + 1), 10000);
  };
  root.querySelector('[data-quote-prev]').addEventListener('click', () => { paused = true; show(index - 1); schedule(); });
  root.querySelector('[data-quote-next]').addEventListener('click', () => { paused = true; show(index + 1); schedule(); });
  toggle.addEventListener('click', () => { paused = !paused; schedule(); });
  document.addEventListener('visibilitychange', schedule);
  controls.hidden = false;
  schedule();
})();
